import ApiClientInstance from '../../common/ApiClient';

export const apiGetImage = (id, companyId) => ApiClientInstance.get(
  `api/accountants/company/media/${id}${companyId ? `?company_id=${companyId}` : ''}`,
);
